/**
 * Created by Mark on 18/04/2017.
 */


import React from 'react';
import { FormattedMessage } from 'react-intl';
import InternationalizationStore from '../../../store/internationalization-store.js'
import {Collapse , Nav , NavItem  ,FormControl , Form , FormGroup , ControlLabel , Col , Panel , Row , ButtonGroup , Button } from 'react-bootstrap';
import ClassService from '../../../services/classes-service.js';
import Search from "../../tables/table.search.component.js";
import LanguageSelector from "../../inputs/language-selector.js";
import ModuleService from '../../../services/screens-service.js';
import ModulesStore from '../../../store/screen-store.js';
import Select from  'react-select';
import CatalogService from '../../../services/catalog-service.js';
import VocabTable from '../../tables/vocab-table.js';
import CurriculumService from '../../../services/curriculums-services.js'
import SearchService from '../../../services/search-service.js';
import $ from 'jquery';

class ContentStep extends React.Component {

    constructor(props){
        super();

        this.props = props;
        this.depth = 0;
        this.state = {
            tabIndex:0,
            selectedLanguage:this.props.data.selectedLanguage || null,
            multipleCurriculums:false,
            modules:[],
            selectedModules:[],
            moduleTiers:[],
            moduleDepth:0,
            selectableVocab:[],
            selectedVocab:this.props.data.selectedVocab || {}
        };

        this.handelTabSelect = this.handelTabSelect.bind(this);
        this.handelSelectLanguage = this.handelSelectLanguage.bind(this);
        this.handelCurriculumSelection = this.handelCurriculumSelection.bind(this);
        
        this.filterReferences = [{}, {}, {}, {}];
        this.currentSelection = 0;
    }

    getStandardOptions(value , label , object){
        return {value:value , label:label , object:object};
    }

    componentDidMount() {
        var curriculums      = this.state.selectedLanguage.getCurriculums();
        this.setState({selectedLanguage:this.state.selectedLanguage , curriculums:curriculums , multipleCurriculums:curriculums.length > 1});
        this.handelCurriculumSelection(this.getStandardOptions(curriculums[0].uid , curriculums[0].getName() , curriculums[0]) , curriculums.length <= 1);
    }

    getCurriculumObject(id , translationID){
        return {value:id , label:<FormattedMessage id={ translationID || "default" } defaultMessage={ "Curriculum" }/>}
    }

    getModuleObject(parent , children , value , translationID , catalog_uid){
        return {parent:parent , children:children , value:value , label:translationID , catalog_uid:catalog_uid};
    }

    handelCurriculumSelection(curriculum , focus){
        this.setState({selectedCurriculum:curriculum});

        CurriculumService.getCurriculumData(curriculum.value).then(function(curriculumData){
        ModuleService.getModules(curriculumData.startScreen).then(function(response){
            ModulesStore.modules = ModulesStore.processModules(response);
            var modules =  ModulesStore.getArray();
            this.setState({modules:modules});
            this.handelModuleSelection(this.state.moduleDepth ,  {
                parent:modules ,
                children:modules[this.state.moduleDepth].subModules ,
                value:modules[this.state.moduleDepth].uid ,
                label:modules[this.state.moduleDepth].getName(),
                catalog_uid:modules[this.state.moduleDepth].catalog_uid
            }, false, false);

            if(focus === true)
            {
                this.filterReferences[0].focus();
            }

        }.bind(this));
        }.bind(this));
    }

    handelTabSelect(tabIndex){
        this.setState({tabIndex:tabIndex})
    }

    getCatalog(){

        var catalog = [];
        for(var idx = 0; idx < this.state.selectedModules.length; idx++)
        {
           if(this.state.selectedModules[idx].catalog_uid) catalog.push(this.state.selectedModules[idx].catalog_uid);
        }

        CatalogService.getCatalogVocab(catalog , this.state.selectedLanguage.ietf).then(function(response){
            this.setState({selectableVocab:response});
            if(!this.state.userChange || this.selectedVocabToArray().length == 0 )
            {
                this.addWholeSection();
                this.props.data.moduleID = this.state.selectedModules[idx - 1].value;
            }
        }.bind(this));
    }


    handelModuleSelection(key ,  option,  isClick, isFocus){
        var depth = key;

    
        if (isClick == undefined){
            isClick = true;
        } 

        if (isFocus == undefined){
            isFocus = false;
        }
        
        if(isFocus){
            this.currentSelection = key;
        }

        var selectedModules = this.state.selectedModules;
            selectedModules[key] = option;
        
        var moduleTiers  = this.state.moduleTiers;
        moduleTiers[key] = this.renderModuleSelector.bind(this , option.parent, key);

        if (typeof (this.filterReferences[this.currentSelection].focus) === 'function'){
            this.filterReferences[this.currentSelection].focus();
        }

        if(selectedModules[key].children && selectedModules[key].children.length > 0)
        {
            depth = depth + 1;
            var newOption = this.getModuleObject(selectedModules[key].children , selectedModules[key].children.subModules , selectedModules[key].children[0].uid , selectedModules[key].children[0].getName() , selectedModules[key].children[0].catalog_uid);
            this.handelModuleSelection(depth , newOption, false, isClick);
        }

        this.setState({selectedModules:selectedModules});
        this.getCatalog();
    }

    handelSelectLanguage(language){
        var curriculums      = language.getCurriculums();
        this.setState({selectedLanguage:language , curriculums:curriculums , multipleCurriculums:curriculums.length > 1});
        this.handelCurriculumSelection(this.getCurriculumObject(curriculums[0].uid , curriculums[0].getName()))
    }

    renderModuleSelector(modules , key){

        let filterModules = modules;

        modules = [];

        for(var idx = 0 ; idx < filterModules.length; idx++){


            if(filterModules[idx].isValid)
            {
                modules.push(filterModules[idx]);
            }

        }

        const options = modules.map(function (module) {
            return { value: module.uid, label: module.getName(), children: module.subModules, parent: modules, catalog_uid: module.catalog_uid }
        });

        this.filterReferences[key] = {};

        return <Select id={"focuse"+key} ref={(input) => { this.filterReferences[key] = input; } } autoFocus={ key == 0 } openOnFocus={true} className={""} onChange={this.handelModuleSelection.bind(this, key)}
            value={this.state.selectedModules[key]} options={options} noResultsText={<FormattedMessage id={"ui-2011"} defaultMessage={"No Results Found"} />}
            placeholder={<FormattedMessage id={'ui-892'} defaultMessage={'Select'} />} />
    }

    renderCurriculumMultiSelect(){


        const options = this.state.selectedLanguage.getCurriculums().map(function(curriculum){
            return  this.getStandardOptions(curriculum.uid , curriculum.getName() , curriculum);
        }.bind(this)); 

        this.filterReferences[0] = {};

        return <Select ref={(input) => { this.filterReferences[0] = input; } } autoFocus={false} openOnFocus={true} className={""} onChange={this.handelCurriculumSelection} value={this.state.selectedCurriculum} options={options}
                noResultsText={<FormattedMessage id={ "ui-2011"} defaultMessage={ "No Results Found" }/>}
                placeholder={<FormattedMessage id={ 'ui-892' } defaultMessage={ 'Select' }/>}/>
    }

    renderFilters(){

        var filters = (this.state.multipleCurriculums ? [this.renderCurriculumMultiSelect()] : []).concat(this.state.moduleTiers.map(function(item , index){
            console.log(index);

            return item();

        }));

        var sm = Math.ceil(12/filters.length);

        return filters.map(function(item){
            return <Col sm={sm}className="actionBar p-5"  >{item}</Col>
        });
    }

    renderSearchHeader(){
        if(this.state.tabIndex == 0) return
    }

    selectedVocabToArray(){
        var objects = Object.keys(this.state.selectedVocab).map(
            function(k , index){
                return this.state.selectedVocab[k]
            }.bind(this));
        return objects
    }

    handelVocabSelection( userChange , vocab ){

        this.setState({selectedVocab:vocab , userChange:userChange})
        this.props.data.selectedVocab = this.selectedVocabToArray();
        if(userChange) this.props.data.moduleID = null;
    }

    handelKeyDown(){
        clearTimeout(this.state.typingTimer);
    }

    handelKeyUp(){
        clearTimeout(this.state.typingTimer);

        this.setState({
            typingTimer:setTimeout(function(){

                if(this.search.value.length <= 0) return;
                SearchService.searchLearning(this.search.value , this.state.selectedLanguage.ietf).then(function(response){
                    this.setState({selectableVocab:response.searchResults})
                }.bind(this));

            }.bind(this), 500)
        });
    }

    addWholeSection(){

        //if( this.state.selectableVocab.length != 10) return;
        var selection = {};

        for(var idx = 0 ; idx < this.state.selectableVocab.length; idx++){
            var vocabObj = this.state.selectableVocab[idx];
            selection[vocabObj.uid] = vocabObj;
        }

        this.handelVocabSelection(false , selection);
    }

    clear(){
        this.handelVocabSelection(true , {});
        this.setState({tabIndex:0});
    }

    render(){

        if(!this.state.curriculums) return null;

        var filter = this.renderFilters();

        if (typeof (this.filterReferences[this.currentSelection].focus) === 'function'){
            this.filterReferences[this.currentSelection].focus();
        }

        let title = "";

        return <div>
                    {this.props.Error}
                    <Collapse in={this.state.tabIndex == 0}>
                        <div>
                            <Row>
                                <Col sm={12} className="p-l-5 actionBar"  >
                                    <ControlLabel><FormattedMessage id={ 'ui-139' } defaultMessage={ 'Search for vocabulary' }/></ControlLabel>
                                </Col>
                            </Row>
                            <Row className="p-l-0 p-r-10">
                                {this.renderFilters()}
                            </Row>
                        </div>
                    </Collapse>
                    {title}
                    <Row>
                        <Nav className="tab-nav p-0" activeKey={this.state.tabIndex} onSelect={this.handelTabSelect}>
                            <NavItem eventKey={0} ><FormattedMessage id={ 'ui-883' } defaultMessage={ 'Content Libary' }/></NavItem>
                            <NavItem disabled={this.selectedVocabToArray().length = 0} eventKey={1} >
                                <FormattedMessage
                                    id="ui-895"
                                    defaultMessage="Selected Content ({total})"
                                    values={{total:String(this.selectedVocabToArray().length) }}
                                    />
                            </NavItem>

                            <Col sm={3} className="pull-right m-t-5 p-0">
                                {this.props.onSubmit}
                            </Col>
                        </Nav>
                    </Row>
                    <Collapse in={this.state.tabIndex == 0}>
                        <Row>
                            <div className="actionBar p-l-0 p-t-0"  >
                                <FormGroup className="b-b-0 m-0">
                                    <div className="b-t-0  b-l-0  b-r-0 input-group">
                                        <span className="input-group-addon"><i className="zmdi zmdi-search"></i></span>
                                        <div className="table-search-field">
                                            <input type="text" onKeyUp={this.handelKeyUp.bind(this)} onKeyDown={this.handelKeyDown.bind(this)} ref={(input) => this.search = input} className="table-search-field form-control" placeholder=""/>
                                        </div>
                                    </div>
                                </FormGroup>
                            </div>
                        </Row>
                    </Collapse>
                    <Row className="p-b-20">
                            <VocabTable selectedVocab={this.state.selectedVocab} onSelect={this.handelVocabSelection.bind(this) } vocab={this.state.tabIndex === 0 ? this.state.selectableVocab : this.selectedVocabToArray()} />
                    </Row>
                </div>

    }
}

export default {
    name: <FormattedMessage id={ 'ui-852' } defaultMessage={ 'Content' }/>,
    title:null,
    removePadding:true,
    navigationTop:true,
    onSubmit: function (done){


        if(!this.props.data.selectedVocab)
        {
            done(new Error(InternationalizationStore.getTranslation("ui-896" ,'You Must have 10 vocabulary items' )));
            return;
        }


        if(this.props.data.selectedVocab.length <= 7 )
        {
            done(new Error(InternationalizationStore.getTranslation("ui-896" ,'You Must have 10 vocabulary items' )));
            return;
        }
        else
        {
            done();
            return;
        }

    },
    component: ContentStep
}


// WEBPACK FOOTER //
// ./src/components/wizard/assignment-steps/select-content.js